import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAllOrdersSortDetails } from '../../../redux/actions/workQueue/allOrdersActions';
import {
  ORDERS_VIEW,
  useViewOrdersOrVehicle,
} from '../ViewOrdersOrVehicle.provider';
import VehicleView from './VehicleView';

export default function ViewTabsOrdersOrVehicle({
  tab,
  children,
  optionalSearchQuery,
}) {
  const { view } = useViewOrdersOrVehicle();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setAllOrdersSortDetails({ sortEnabled: false }));
  }, [dispatch]);

  if (view === ORDERS_VIEW) return children;
  else
    return <VehicleView tab={tab} optionalSearchQuery={optionalSearchQuery} />;
}
